import React, { forwardRef, useEffect, useState } from 'react';
import { Breadcrumb } from "components";
import { translate } from "react-switch-lang";
import { AddBox, ArrowDownward } from '@material-ui/icons';
import MaterialTable from 'material-table';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import CircularProgress from '@material-ui/core/CircularProgress';
import PrintIcon from '@material-ui/icons/Print';
import CloudDownloadOutlinedIcon from '@material-ui/icons/CloudDownloadOutlined';
import Swal from 'sweetalert2';
import { addPlan, getPlans, uploadPlanFile } from 'service/managePlanService';
import { getProducts } from 'service/manageProductService';
import TableToolbar from "components/tableToolbar";
import ImportDataModal from "components/importDataModal";

const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
    print: forwardRef((props, ref) => <PrintIcon {...props} ref={ref} />),
    DownloadTable: forwardRef((props, ref) => (
        <CloudDownloadOutlinedIcon
            style={{ fontSize: 'larger', fontWeight: 'bolder' }}
            {...props}
            ref={ref}
        />
    ))
};

const ManagePlans = (props) => {
    const [loader, setLoader] = useState(false);
    const [data, setData] =  useState([]);
    const [productLoading, setProductLoading] = useState(true);
    const [products, setProducts] = useState({});
    const [showImportDataModal, setShowImportDataModal] = useState(false);
    const [uploadFileLoading, setUploadFileLoading] = useState(false);

    useEffect(() => {
        getData();
        getProductsData();
      }, []);
    
      const getData = async (loading = true) => {
        setLoader(loading);
        await getPlans()
          .then((res) => {
            if(res.data && typeof res.data === 'object') {
              setData(res.data || []);
            }
          })
          .catch((error) => {})
          .finally(() => {
            setLoader(false);
          });
      };
      
  const getProductsData = async () => {
    setProductLoading(true);
    await getProducts()
      .then((res) => {
        const newProducts = {};
        const data = res.data || [];
        if(typeof data === 'object') {
          data.map((p) => {
            newProducts[p.product_code] = p.product_name;
          });
          setProducts(newProducts);
        }
      })
      .catch((error) => {})
      .finally(() => {
        setProductLoading(false);
      });
  };
    
      const onAddData = (newData = {}, isUpdate) => {
        const data = {
            ...newData,
            product_name: products[newData.region_code],
            plan_price: Number(newData.plan_price),
            sip_plan_rate: Number(newData.sip_plan_rate),
            isUpdate,
          };
        return new Promise((resolve, reject) => {
          addPlan(data)
            .then((res) => {
              getData(false).finally(() => {
                resolve(true);
              });
              if (res.status !== 200) {
                Swal.fire({
                  icon: "error",
                  title: res.message || "Error occured",
                });
                reject(res.error);
              } else {
                Swal.fire({
                  icon: "success",
                  title: `Plan ${isUpdate ? "Updated" : "Added"} Successfully`,
                });
              }
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                title: error.message || "Error occured",
              });
              reject(error);
            });
        });
      };
    
  const uploadFile = (file) => {
    const formData = new FormData();
    formData.append('plan', file);
  
    setUploadFileLoading(true);
    uploadPlanFile(formData).then(res => {
      if(res.status === 200) {
        getData();
        setShowImportDataModal(false);
        Swal.fire({
          icon: "success",
          title: props.t("Data Imported"),
        });
      } else {
        Swal.fire({
          icon: "error",
          title: res.message || "Error occured",
        });
      }
    }).catch(error => {
      Swal.fire({
        icon: "error",
        title: error.message || "Error occured",
      });
    }).finally(() => {
      setUploadFileLoading(false);
    })
  }

    return (
        <>
        <Breadcrumb title={props.t("Manage Plans")} />
            <div className="app-wrapper">
                <div>
                    {loader || productLoading ? (
                        <div
                        className="d-flex justify-content-center align-items-center"
                            style={{
                                height:
                                    props.width >= 1200
                                        ? 'calc(100vh - 259px)'
                                        : 'calc(100vh - 238px)'
                            }}
                        >
                            <CircularProgress />
                        </div>
                    ) : (
                        <div className="animated slideInUpTiny animation-duration-3">
                            <MaterialTable
                                icons={tableIcons}
                                columns={[
                                    {
                                        title: props.t('Product'),
                                        field: 'product_code',
                                        lookup: products,
                                    },
                                    { title: props.t('Plan Name'), field: 'plan_name' },
                                    { title: props.t('Plan Code'), field: 'plan_code', editable: "onAdd" },
                                    { title: props.t('Rate'), field: 'plan_price' },
                                    { title: props.t('SIP Rate Plan'), field: 'sip_plan_rate' }


                                ]}
                                data={data}
                                options={{
                                    actionsColumnIndex: -1,
                                    addRowPosition: 'first',
                                    showTitle: false,
                                    filtering: true,
                                    sorting: true
                                }}
                                localization={{
                                    header: {
                                      actions: props.t("Action"),
                                    },
                                  }}
                                  components={{
                                    Toolbar: (propsToolbar) => (
                                      <TableToolbar onClickImport={() => setShowImportDataModal(true)} {...propsToolbar} t={props.t} />
                                    ),
                                  }}
                                editable={{
                                    onRowAdd: (data) => onAddData(data, false),
                                    onRowUpdate: (data) => onAddData(data, true),
                                    onRowDelete: oldData => new Promise((resolve, reject) => {
                                        setTimeout(() => {
                                            const dataDelete = [...data];
                                            const index = oldData.tableData.id;
                                            dataDelete.splice(index, 1);
                                            setData([...dataDelete]);

                                            resolve();
                                        }, 1000);
                                    }),
                                }}
                            />
                        </div>
                    )}
                </div>
            </div>
            <ImportDataModal onImport={uploadFile} loading={uploadFileLoading} show={showImportDataModal} setShow={setShowImportDataModal}/>
        </>
    );
};

export default translate(ManagePlans);
